var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout__wide"},[_c('router-view'),(!_vm.$route.params.pageSlug)?_c('projects',{attrs:{"projects":_vm.projects}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }